import React, { memo, useMemo, useRef } from 'react'

import { Dropdown } from 'components/Common'
import TimeSlotCarousel from 'components/Appointments/TimeSlotCarousel'
import Loading from 'components/Loading'
import Divider from '../Divider'
import defaultStyles from './styles'

import { mergeStyles } from '@enlyt/base'
import addressToString from 'helpers/addressToString'

const BookingSelection = props => {
  const styles = mergeStyles(defaultStyles, props.style)
  const {
    loadingInitialTimeSlots,
    locationSelected,
    departments,
    onLocationSelected,
    visitTypes,
    reasonForVisitSelected,
    onReasonForVisitSelected,
    errorInitialTimeSlots,
    selectedTimeslot,
    selectTimeSlot,
    selectedDate,
    setSelectedDate,
    selectedDayIndex,
    setSelectedDayIndex,
    selectedMonthIndex,
    setSelectedMonthIndex,
    activeDateSlideIndex,
    setActiveDateSlideIndex,
    availableDaysInCurrentMonth,
    setAvailableDaysInCurrentMonth,
    timeslots,
    getFirstPartNewTimeSlotsForMonth,
    getSecondPartNewTimeSlotsForMonth,
    loadingOtherTimeSlots,
    errorOtherTimeSlots,
    providerId,
    providerIdType
  } = props

  const childRef = useRef(null)

  const dropdownOptions = useMemo(() => {
    return departments?.map(l => ({
      key: l.departmentId,
      value: l.departmentId,
      text: addressToString(l.address)
    }))
  }, [departments])

  const reasonsForVisit = useMemo(() => {
    return visitTypes?.map(l => ({
      key: l.visitTypeId,
      value: l.visitTypeId,
      text: l.displayName
    }))
  }, [visitTypes])

  const goToCurrentDate = () => {
    childRef?.current?.goToCurrentDate()
    childRef?.current?.clearSelectedDate()
  }

  const locationDropdownHandler = (e, data) => {
    goToCurrentDate()
    onLocationSelected(data.value)
  }

  const reasonDropdownHandler = (e, data) => {
    goToCurrentDate()
    onReasonForVisitSelected(data.value)
  }

  const renderTimeSlots = () => {
    if (loadingInitialTimeSlots) {
      return <Loading />
    }

    if (errorInitialTimeSlots) {
      return <p>Something went wrong</p>
    }

    return (
      <TimeSlotCarousel
        ref={childRef}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        selectedDayIndex={selectedDayIndex}
        setSelectedDayIndex={setSelectedDayIndex}
        selectedMonthIndex={selectedMonthIndex}
        setSelectedMonthIndex={setSelectedMonthIndex}
        activeDateSlideIndex={activeDateSlideIndex}
        setActiveDateSlideIndex={setActiveDateSlideIndex}
        availableDaysInCurrentMonth={availableDaysInCurrentMonth}
        setAvailableDaysInCurrentMonth={setAvailableDaysInCurrentMonth}
        timeslots={timeslots}
        selectTimeSlot={selectTimeSlot}
        providerId={providerId}
        providerIdType={providerIdType}
        getFirstPartNewTimeSlotsForMonth={getFirstPartNewTimeSlotsForMonth}
        getSecondPartNewTimeSlotsForMonth={getSecondPartNewTimeSlotsForMonth}
        selectedTimeslotId={selectedTimeslot?.id}
        loadingOtherTimeSlots={loadingOtherTimeSlots}
        errorOtherTimeSlots={errorOtherTimeSlots}
      />
    )
  }

  return (
    <>
      <div style={styles.section}>
        {dropdownOptions && (
          <Dropdown
            placeholder={dropdownOptions[0]?.text}
            label='Practice location:'
            options={dropdownOptions}
            onChange={locationDropdownHandler}
            value={locationSelected?.departmentId}
            style={styles.dropdown}
          />
        )}
        {reasonsForVisit && (
          <Dropdown
            placeholder={reasonsForVisit[0]?.text}
            label='Reason for visit:'
            options={reasonsForVisit}
            onChange={reasonDropdownHandler}
            value={reasonForVisitSelected?.visitTypeId}
          />
        )}
      </div>
      <Divider />
      {renderTimeSlots()}
    </>
  )
}

export default memo(BookingSelection)
